export default __webpack_public_path__ + "static/media/2065.d88b7ec4.png";